import "./vendor-styles"; // get vendor styles
import "./vendor"; // get vendor
import "./app-styles"; // get app styles

import "./app.module"; // get app module
import "./main.js"; // get main

// function importAll(r) {
//     r.keys().forEach(r);
// }

const cache = {};
function importAll (r) {
    r.keys().forEach(key => cache[key] = r(key));
}

// get all of the app's js files - excluding modules and spec files
importAll(
    require.context("./", true, /^(?!.*\.module\.js$)^(?!.*\.(spec|test)\.(js)$).*\.(js)$/)
);

require('./app-templates'); // get app's templates
